const isDebugEnabled = () => {
  if (process.env.NODE_ENV !== 'production') return true;
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem('lumirae_debug') === '1';
};

export const reportClientError = (scope, error, details = {}) => {
  if (!isDebugEnabled()) return;
  const payload = Object.keys(details).length > 0 ? details : undefined;
  console.error(`[Lumirae:${scope}]`, error, payload);
};

export default reportClientError;
